<template>
    <div class="form-field">
        <label>动态</label>
        <div class="content">
            <el-radio-group :value="dynamic" @input="setDynamic">
                <el-radio :label="0">非动态</el-radio>
                <el-radio :label="1">动态</el-radio>
            </el-radio-group>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-field{
        align-items: flex-start;
    }
</style>

<script>
	export default {
		props:['isDynamic'],
		data(){
			return {}
		},
		computed: {
			selected() {
				return this.$store.state.selected
			},
			dynamic(){
				const id = this.$store.state.selected.id
                const state = this.$store.state
				const act = state.actions.find(item=>item.element+ '_'+item.name === id)
                if(act){
					return state.slots.findIndex(item=>item.name === `##${act.element}`)>-1?1:0
                }else{
					return 0
                }
            }
		},
		methods: {
			setDynamic(value) {
                this.$store.commit('set_action_dynamic', {
                	id: this.selected.id,
					isDynamic: +value
                })
			}
		},
        watch:{
			isDynamic(value){
				this.dynamic = value
            }
        }
	}
</script>
